import { Link } from 'react-router-dom';

import { useMarketplace } from '@/lib/api/hooks';

/**
 * Empty-stack nudge toward the Shop tab: a few product renders and one CTA.
 * Images come from the live marketplace catalog; with none loaded yet the
 * card still renders its copy and link, so it never blocks the empty state.
 */
export function ShopTreatmentsCard() {
  const marketplace = useMarketplace();
  // Only what the Shop itself would list (it hides owned products), and the
  // full product photo first: transparent scene renders crop badly as covers.
  const images = (marketplace.data?.products ?? [])
    .filter((p) => !p.owned)
    .map((p) => ({ id: p.id, name: p.title, src: p.hero_image_url || p.scene_image_url }))
    .filter((p): p is { id: string; name: string; src: string } => Boolean(p.src))
    .slice(0, 3);

  return (
    <section
      aria-label="See treatments in our shop"
      className="border border-line-subtle bg-raised flex flex-col md:flex-row md:items-stretch"
    >
      {images.length > 0 && (
        <div className="flex md:w-[24rem] shrink-0 bg-sunken">
          {images.map((img) => (
            <img
              key={img.id}
              src={img.src}
              alt={img.name}
              loading="lazy"
              className="flex-1 min-w-0 aspect-square object-cover"
            />
          ))}
        </div>
      )}
      <div className="flex-1 min-w-0 p-15 flex flex-col gap-10 justify-center">
        <h2 className="font-mono text-15 uppercase leading-110">See treatments in our shop</h2>
        <p className="text-14 text-ink-secondary leading-135 max-w-[48ch]">
          Browse peptides and wellness treatments, reviewed by a clinician and shipped to your door.
        </p>
        <Link
          to="/app/shop"
          className="self-start bg-black text-white font-body text-14 px-15 py-10 inline-flex items-center gap-10"
        >
          Browse the shop <span aria-hidden>▶</span>
        </Link>
      </div>
    </section>
  );
}
